import IComponent from "components/commons/IComponent";
import "./DetailPanels.scoped.css";
import CellTable from "components/SearchResult/DetailPanels/TableModules/CellTable";
import SingleValueTable from "components/SearchResult/DetailPanels/TableModules/SingleValueTable";
import MultiValueTable from "components/SearchResult/DetailPanels/TableModules/MultiValueTable";
import { dataProcessFunctions } from "./dataProcessFunctions";

class DetailInfo extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      detailsSlopeWall: [
        {
          alias: "Feature Ref. No.",
          field: "FEATURE",
          value: "",
        },
        {
          alias: "Location",
          field: "LOCATION",
          value: "",
        },
        {
          alias: "Date of Inspection",
          field: "PREP_DATE",
          value: "",
        },
        {
          alias: "Data Source",
          field: "DATA_SOURCE",
          value: "",
        },
        {
          alias: "Slope Part Drainage",
          field: "SlopePartDrainages",
          value: "",
          tableSpec: [
            {
              alias: "Position",
              field: "SU_POSITION",
              value: [],
            },
            {
              alias: "Size (mm)",
              field: "SU_SIZE",
              value: [],
            },
          ],
        },
        {
          alias: "Wall Part Drainage",
          field: "WallPartDrainages",
          value: "",
          tableSpec: [
            {
              alias: "Position",
              field: "WU_POSITION",
              value: [],
            },
            {
              alias: "Size (mm)",
              field: "WU_SIZE",
              value: [],
            },
          ],
        },
      ],
      detailsSlopePart: [
        {
          alias: "Slope Parts",
          field: "SlopeParts",
          value: "",
          multiValueTableSpec: [
            {
              alias: "No.",
              field: "Order",
              value: [],
            },
            {
              alias: "Surface Protection (%)",
              field: [
                {
                  prefix: "Bare",
                  name: "SF_BARE",
                },
                {
                  prefix: "Vegetated",
                  name: "SF_VEGETATED",
                },
                {
                  prefix: "Chunam",
                  name: "SF_CHUNAM",
                },
                {
                  prefix: "Shotcrete",
                  name: "SF_SHOTCETE",
                },
                {
                  prefix: "Other Cover",
                  name: "SF_CVR_OTHERS",
                },
              ],
              value: [],
            },
            {
              alias: "Material Description",
              field: [
                {
                  prefix: "Material Type",
                  name: "SF_MAT",
                },
                {
                  prefix: "Geology",
                  name: "SF_GEOLOGY",
                },
              ],
              value: [],
            },
            {
              alias: "Dimension",
              field: [
                {
                  prefix: "Max. Height (m)",
                  name: "SF_HEIGHT",
                },
                {
                  prefix: "Length (m)",
                  name: "SF_LENGTH",
                },
                {
                  prefix: "Average Angle (degree)",
                  name: "SF_ANGLE",
                },
              ],
              value: [],
            },
            {
              alias: "Berms",
              field: [
                { prefix: "No. of Berms", name: "SF_BERM" },
                { prefix: "Min. Berm Width (m)", name: "SF_BERMW" },
              ],
              value: [],
            },
            {
              alias: "Weepholes",
              field: [
                { prefix: "Size (mm)", name: "SW_SIZE" },
                { prefix: "Spacing (m)", name: "SW_SPC" },
              ],
              value: [],
            },
          ],
        },
      ],
      detailsWallPart: [
        {
          alias: "Wall Parts",
          field: "WallParts",
          value: "",
          multiValueTableSpec: [
            {
              alias: "No.",
              field: "Order",
              value: [],
            },
            {
              alias: "Type of Wall",
              field: [
                {
                  prefix: "Wall Material",
                  name: "WF_TYPE",
                },
                {
                  prefix: "Wall Location",
                  name: "WF_LOCATION",
                },
              ],
              value: [],
            },
            {
              alias: "Dimension",
              field: [
                {
                  prefix: "Max. Height (m)",
                  name: "WF_HEIGHT",
                },
                {
                  prefix: "Length (m)",
                  name: "WF_LENGTH",
                },
                {
                  prefix: "Face Angle (degree)",
                  name: "WF_ANGLE",
                },
              ],
              value: [],
            },
            {
              alias: "Berms",
              field: [
                { prefix: "No. of Berms", name: "WF_BERM" },
                { prefix: "Min. Berm Width (m)", name: "WF_BERMW" },
              ],
              value: [],
            },
            {
              alias: "Weepholes",
              field: [
                { prefix: "Size (mm)", name: "WW_SIZE" },
                { prefix: "Spacing (m)", name: "WW_SPC" },
              ],
              value: [],
            },
          ],
        },
      ],
      services: [
        {
          alias: "Services",
          field: "Services",
          value: [],
          tableSpec: [
            {
              alias: "Utilities Type",
              field: "UTIL_TYPE",
              value: [],
            },
            {
              alias: "Size (mm)",
              field: "UTIL_SIZE",
              value: [],
            },
            {
              alias: "Location",
              field: "UTIL_LOCATION",
              value: [],
            },
            {
              alias: "Remarks",
              field: "REMARK",
              value: [],
            },
          ],
        },
      ],
    };
  }
  componentDidMount() {
    this.props.isShowTabCallback(true);
    let dataProcessClassObj = new dataProcessFunctions();

    let tmpDetailsSlopeWall = Object.assign([], this.state.detailsSlopeWall);
    tmpDetailsSlopeWall = dataProcessClassObj.assignCellTableValues(
      tmpDetailsSlopeWall,
      this.props.attributes
    );

    let tmpDetailsSlopePart = Object.assign([], this.state.detailsSlopePart);
    tmpDetailsSlopePart = dataProcessClassObj.assignMultiValueTableValues(
      tmpDetailsSlopePart,
      this.props.attributes
    );

    let tmpDetailsWallPart = Object.assign([], this.state.detailsWallPart);
    tmpDetailsWallPart = dataProcessClassObj.assignMultiValueTableValues(
      tmpDetailsWallPart,
      this.props.attributes
    );

    let tmpServices = Object.assign([], this.state.services);
    tmpServices = dataProcessClassObj.assignCellTableValues(
      tmpServices,
      this.props.attributes
    );

    this.setState({
      detailsSlopeWall: tmpDetailsSlopeWall,
      detailsSlopePart: tmpDetailsSlopePart,
      detailsWallPart: tmpDetailsWallPart,
      services: tmpServices,
    });
  }
  componentWillUnmount() {}
  render() {
    return (
      <div>
        <div className="SubPanelTitle">Details of Slope / Retaining Wall</div>
        <CellTable data={this.state.detailsSlopeWall} />
        <div className="SubPanelTitle">Slope Part</div>
        <MultiValueTable data={this.state.detailsSlopePart[0]} />
        <div className="SubPanelTitle">Wall Part</div>
        <MultiValueTable data={this.state.detailsWallPart[0]} />
        <div className="SubPanelTitle">Services</div>
        <SingleValueTable data={this.state.services} />
      </div>
    );
  }
}

export default DetailInfo;
